import { render, staticRenderFns } from "./PatientInformation.vue?vue&type=template&id=2fadaebc&"
import script from "./PatientInformation.vue?vue&type=script&lang=js&"
export * from "./PatientInformation.vue?vue&type=script&lang=js&"
import style0 from "./PatientInformation.vue?vue&type=style&index=0&id=2fadaebc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports